import type { QuestionPayload } from '../../protocol/types';

interface Props {
  question: QuestionPayload;
  /** When set, the answered option's `value` — locks every button. */
  answeredValue?: string;
  onSelect: (value: string) => void;
}

export function QuestionCard({ question, answeredValue, onSelect }: Props) {
  const answered = answeredValue !== undefined;
  return (
    <div className="animate-fade-in rounded-xl border border-divider bg-surface p-4 shadow-sm">
      <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-accent">
        {question.title}
      </div>
      <div className="mb-3 whitespace-pre-wrap text-[14px] leading-relaxed text-text-primary">
        {question.question}
      </div>
      <div className="flex flex-wrap gap-2">
        {question.options.map((opt, i) => {
          const value = opt.value ?? opt.label;
          const selected = answeredValue === value;
          const label = selected && opt.selectedLabel ? opt.selectedLabel : opt.label;
          return (
            <button
              key={`${value}-${i}`}
              type="button"
              disabled={answered}
              onClick={() => onSelect(value)}
              className={`rounded-lg px-3.5 py-1.5 text-[13px] font-medium transition-colors disabled:cursor-default ${
                selected
                  ? 'bg-accent text-white'
                  : answered
                    ? 'border border-divider bg-elevated text-text-faint'
                    : 'border border-divider bg-elevated text-text-primary hover:border-accent hover:text-accent'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
